<template>
  <div id="sign-providers">
    <v-btn
      :disabled="loading"
      :color="$vuetify.theme.dark ? 'white' : 'darkTextGrey'"
      outlined
      class="google-button elevation-0"
      @click="signInGoogle"
    >
      <img :src="require('@/assets/login/google.svg')" width="18px" />
      <span class="ml-3">{{ $t('views.login.continueWithGoogle') }}</span>
    </v-btn>

    <div class="or-separator">
      <v-divider />
      <span>
        {{ $t('views.login.or') }}
      </span>
      <v-divider />
    </div>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import { get } from 'lodash'
import { getUser, createUser } from '@/lib/api.js'
import { mapActions } from 'vuex'

export default {
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    ...mapActions({ login: 'LOGIN' }),
    async createFiliosUser({ uid, email }) {
      try {
        await createUser({ uid, data: { email } })
      } catch (error) {
        this.error = get(error, 'data.name', null)
        this.$emit('update:loading', false)
      }
    },
    async signInGoogle() {
      this.$emit('update:loading', true)
      let response
      try {
        const provider = new firebase.auth.GoogleAuthProvider()
        response = await firebase.auth().signInWithPopup(provider)
      } catch (error) {
        this.$emit('update:loading', false)
        this.$emit('setErrorCode', error.code || 'errorWithGoogle')
        return
      }
      try {
        await getUser({ uid: response.user.uid })
      } catch (error) {
        if (error.status === 404) {
          await this.createFiliosUser({
            uid: response.user.uid,
            email: response.user.email,
          })
        } else {
          this.$emit('update:loading', false)
          this.$emit('setErrorCode', error.code || 'maintenanceError')
          return
        }
      }
      await this.login()
    },
  },
}
</script>

<style lang="scss">
#sign-providers {
  .or-separator {
    display: flex;
    align-items: center;
    margin: 20px 0 20px 0px;
    span {
      font-size: 15px;
      font-weight: 300;
      margin: 0px 15px 0 15px;
    }
    hr {
      width: 100%;
    }
  }
  .google-button {
    width: 100%;
    font-weight: 500;
  }
}
.theme--dark {
  #sign-providers {
    .or-separator {
      span {
        color: #a5a5a5;
      }
      hr {
        border-color: #a5a5a5;
      }
    }
  }
}
</style>
